import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";

/** Hält die gewählte Apotheke über ein Neuladen mitten im Einlöse-Vorgang hinweg. */
@Injectable({
  providedIn: "root",
})
export class VoucherPharmacyStorageService {
  // ⚠ Ohne Ablauf stünde nach einem App-Absturz Tage später noch eine Vorauswahl da.
  private static readonly MAX_AGE_MS = 30 * 60 * 1000;

  constructor(private _configService: ConfigService) {}

  public save(pharmacy: string | null): void {
    if (!pharmacy) {
      this.clear();

      return;
    }

    try {
      localStorage.setItem(
        this.key(),
        JSON.stringify({ pharmacy, savedAt: Date.now() }),
      );
    } catch {
      // Ohne Speicher geht nur die Wiederherstellung verloren, nicht der Vorgang.
    }
  }

  public load(): string | null {
    try {
      const stored = JSON.parse(localStorage.getItem(this.key()) ?? "null");

      if (
        typeof stored?.pharmacy !== "string" ||
        Date.now() - stored.savedAt > VoucherPharmacyStorageService.MAX_AGE_MS
      ) {
        return null;
      }

      return stored.pharmacy;
    } catch {
      return null;
    }
  }

  public clear(): void {
    try {
      localStorage.removeItem(this.key());
    } catch {
      // siehe save()
    }
  }

  private key(): string {
    return `${this._configService.config.storage.localStoragePrefix}voucher-pharmacy`;
  }
}
